const useVirtualBattery = () => {

  const sortDistribution = ({distribution, sortBy="contractName"}) => {
    return distribution?.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return -1;
      if (a[sortBy] > b[sortBy]) return 1;
      return 0;
    }) ?? distribution;
  }

  const isBateriaVirtualActive = (bateriaVirtualContract) => {
    /**
     * Determines if a "bateria virtual contract" record is active based on its date configuration.
     *
     * A record is considered active if:
     * - Today's date is inside the configured `data_inici` and `data_final` range.
     * - `data_final` is not set, and `data_inici` is earlier than today's date.
     *
     * @returns {boolean} - `true` if the record is active, `false` otherwise.
     */

    const today = new Date();
    const dataInici = new Date(bateriaVirtualContract.data_inici);
    const dataFinal = bateriaVirtualContract.data_final ? new Date(bateriaVirtualContract.data_final) : null;

    if (dataFinal) {
        return today >= dataInici && today <= dataFinal;
    }
    return today >= dataInici;
}

  const getAllBateriaVirtualsFromContracts = ({ contracts, excludeContractName }) => {
    let all = [];

    for (const contract of contracts) {
      if (contract.name != excludeContractName) {
        for (const bateriaVirtual of contract.bateria_virtual) {
          all.push(bateriaVirtual);
        }
      }
    }
    return all;
  };

  const getBatteriesDistribution = ({ contracts, excludeContractName, excludeBatteryId }) => {
    let groupedBatteryDistribution = {};

    for (const contract of contracts) {
      if (contract.name != excludeContractName) {
        for (const bateriaVirtual of contract.bateria_virtual) {
          const batteryDistribution = {
            "contractId": contract.id,
            "pes": bateriaVirtual.pes,
            "pesPercentage": bateriaVirtual.pes_percentatge,
            "contractName": contract.name,
            "isBateriaVirtualActive": isBateriaVirtualActive(bateriaVirtual)
          }
          if (bateriaVirtual.bateria.id in groupedBatteryDistribution) {
            groupedBatteryDistribution[bateriaVirtual.bateria.id].distribution.push(batteryDistribution);
          } else {
            groupedBatteryDistribution[bateriaVirtual.bateria.id] = {
              batteryId: bateriaVirtual.bateria.id,
              batteryName: bateriaVirtual.bateria.name,
              distribution: [ batteryDistribution ]
            };
          }
        }
      }
    }

    if (excludeBatteryId in groupedBatteryDistribution) {
      delete groupedBatteryDistribution[excludeBatteryId];
    }

    // INFO: Sort the distributions (is not optimized, the stress, sorry, right now I don't care if goes slow, you can fix it)
    for (const batteryDistribution of Object.values(groupedBatteryDistribution)) {
      batteryDistribution.distribution = sortDistribution({ distribution: batteryDistribution.distribution });
    }
     return groupedBatteryDistribution;
  };


  const getBatteryDistribution = ({contracts, batteryId}) => {
    const allDistributted = getBatteriesDistribution({contracts});
    return allDistributted[batteryId];
  }



  return {
    getAllBateriaVirtualsFromContracts,
    getBatteriesDistribution,
    getBatteryDistribution,
    sortDistribution,
    isBateriaVirtualActive
  };
};

export default useVirtualBattery;
